import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';

import { clearMessage, clearMessageError, postConversation, setMessage, setSubject} from 'containers/Messaging/store/actions';

import ConfirmModal from 'components/Modal/ConfirmModal';
import Modal from 'components/Modal';
import MessageModalForm from './MessageModalForm';

class MessageModal extends React.Component {
    static propTypes = {
        onCloseModal: PropTypes.func,
        onRef: PropTypes.func.isRequired,
        selectedProfilesToDM: PropTypes.array
    };

    constructor() {
        super();

        this.state = {
            showMessageModal: false,
            showSuccessModal: false
        };
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    _closeModal() {
        this.setState({showMessageModal: false});
        this.props.clearMessage();
        this.props.clearMessageError();
        if(this.props.onCloseModal != null) {
            this.props.onCloseModal();
        }
    }

    handleSubmit(isValid) {
        if(isValid === true) {
            this.props.postConversation(this.props.selectedProfilesToDM)
                .then((res) => {
                    this.setState({
                        showMessageModal: false,
                        showSuccessModal: true
                    });
                })
        }
    }

    showMessageModal() {
        this.setState({showMessageModal: true});
    }

    render() {
        return (
            <div>
                <Modal className="a-modal--message-modal"
                       closeModal={this._closeModal.bind(this)}
                       contentLabel="Send a message in this modal"
                       show={this.state.showMessageModal === true}
                       title={`Send Message${this.props.selectedProfilesToDM && this.props.selectedProfilesToDM.length > 0 ? ` to ${this.props.selectedProfilesToDM.length} Freelancer${this.props.selectedProfilesToDM.length !== 1 ? 's' : ''}` : ''}`}>

                    <MessageModalForm
                        closeModal={this._closeModal.bind(this)}
                        error={this.props.messaging.messageError}
                        isSending={this.props.messaging.isSending}
                        message={this.props.messaging.message}
                        subject={this.props.messaging.subject}
                        onInvalid={this.handleSubmit.bind(this, false)}
                        onValid={this.handleSubmit.bind(this, true)}
                        setMessage={this.props.setMessage.bind(this)}
                        setSubject={this.props.setSubject.bind(this)}
                    />
                </Modal>

                <ConfirmModal
                    confirmOnClick={() => this.setState({showSuccessModal: false})}
                    confirmText="OK"
                    declineOnClick={() => this.setState({showSuccessModal: false})}
                    show={this.state.showSuccessModal === true}
                    title="Message successfully sent"
                />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        accounts: state.accounts,
        auth: state.auth,
        messaging: state.messaging
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearMessage: () => dispatch(clearMessage()),
        clearMessageError: () => dispatch(clearMessageError()),
        postConversation: (profiles) => dispatch(postConversation(profiles)),
        setMessage: (message) => dispatch(setMessage(message)),
        setSubject: (subject) => dispatch(setSubject(subject))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageModal);



// WEBPACK FOOTER //
// ./src/components/Modal/MessageModal/index.js